import React from 'react';
import {reset} from 'redux-form';
import {connect} from 'react-redux'
import { stopSubmit } from 'redux-form'
import Paper from 'material-ui/Paper';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentCreate from 'material-ui/svg-icons/content/create';
import ContentRemove from 'material-ui/svg-icons/content/remove';
import * as colors from 'material-ui/styles/colors';


import PageBase from '../../../components/PageBase';
import DataTables from '../../../components/DataTables/DataTables'

import listHeader from './listHeader'
import gStyles from '../../../styles'

import CostMasterForm from './CostMasterForm'

import * as actions from '../../../actions'

const MASTER_TYPE = "cost"


const validate = values => {
  const errors = {}
  const requiredFields = [
    "kind",
    "name",
  ]
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = '必須入力'
    }
  })
  return errors
}


const validateSearch = values => {
  const errors = {}
  return errors
}


class CostMasterPage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      open: false
    }
  }

  componentDidMount() {
    const {
      form,
      page
    } = this.props

    this.props.handleInit(form, page)
  }


  handlePreviousPageClick(form, page, editIndex) {

    if (editIndex) {
      alert('編集モード中はページ移動はできません。')
      return
    }
    const prevPage = page - 1
    this.props.handlePageClick(prevPage, form)
  }

  handleNextPageClick(form, page, editIndex) {

    if (editIndex) {
      alert('編集モード中はページ移動はできません。')
      return
    }
    const nextPage = page + 1
    this.props.handlePageClick(nextPage, form)
  }

  handleConfirmOpen(id, item) {
    this.setState(Object.assign({}, this.state, {
      id: id,
      item: item,
      open: true
    }))
  };

  handleConfirmClose() {
    this.setState(Object.assign({}, this.state, {
      open: false
    }))
  };

  handlePageReset() { 
    this.setState(Object.assign({}, this.state, {
      page: 1
    }))
  }

  render() {

    const {
      handleFormSearchClick,
      handleFormRegistClick,
      handleFormEditClick,
      handleFormDeleteClick,
      handleFormResetClick,
      handleLocalStorageSave,
      tmpForm,
      history
    } = this.props

    const page = this.props.page
    const count = this.props.count
    const form = this.props.form || {}
    const list = this.props.list || []

    let editIndex;
    const dataList = list.map((x, index) => {

      const actions = (
        <div style={{display: "flex", justifyContent: 'flex-end'}}>
          <div style={{ margin: '10px 10px' }}>
            <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.grey400} onTouchTap={!form.id && handleFormEditClick(x.id)} disabled={form.id ? true : false}>
              <ContentCreate />
            </FloatingActionButton>
          </div>
          <div style={{ margin: '10px 10px' }}>
            <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.red300}
                                  onTouchTap={!form.id && this.handleConfirmOpen.bind(this,x.id, x.work)} disabled={form.id ? true : false}
            >
              <ContentRemove />
            </FloatingActionButton>
          </div>
        </div>
      )

      if (form.id == x.id) {
        editIndex = index
      }

      return {
        kindName: x.kindName,
        name: x.name,
        actions: actions,
      }

    })

    const dialogActions = [
      <FlatButton
        label="キャンセル"
        primary={true}
        onTouchTap={this.handleConfirmClose.bind(this)}
      />,
      <FlatButton
        label="削除"
        primary={true}
        keyboardFocused={true}
        onTouchTap={handleFormDeleteClick(this.state.id, page, this.handleConfirmClose.bind(this), form)}
      />,
    ];

    const editColor = form.id && {backgroundColor: colors.lightGreen50}

    return (

      <PageBase title="費用マスタ" >

        <div>

          <div style={gStyles.searchBoxContainer}>

            <Paper style={{...gStyles.contentsPaper, ...editColor}}>
              <CostMasterForm 
                onFormRegistClick={handleFormRegistClick(form.id, page, tmpForm)}
                onFormResetClick={handleFormResetClick}
                onFormSearchClick={handleFormSearchClick(this.handlePageReset.bind(this))}
                initialValues={form}
                onLocalStorageSave={handleLocalStorageSave}
              />
            </Paper>

          </div>

          <Paper style={{...gStyles.contentsPaper}}>
            <DataTables
              editIndex={editIndex}
              tableStyle={{overflow: 'hidden', tableLayout: ''}}
              tableBodyStyle={{overflowX: 'auto'}}
              height={'auto'}
              showRowHover={true}
              columns={listHeader}
              data={dataList}
              page={page}
              showRowSizeControls={false}
              onNextPageClick={this.handleNextPageClick.bind(this, form, page, editIndex)}
              onPreviousPageClick={this.handlePreviousPageClick.bind(this, form, page, editIndex)}
              count={count}
            />
          </Paper>

        </div>


         <Dialog
          title="マスター削除"
          actions={dialogActions}
          modal={true}
          open={this.state.open}
          onRequestClose={this.handleConfirmClose.bind(this)}
        >
          {this.state.item} を削除します。よろしいですか？
        </Dialog> 

      </PageBase>

    )
  }

}

const mapStateToProps = (state) => ({
  list: state.master.list[MASTER_TYPE] ,
  count: state.master.count[MASTER_TYPE],
  form: state.master.form[MASTER_TYPE],
  page: state.master.page[MASTER_TYPE],
  tmpForm: state.master.tmpForm[MASTER_TYPE],
})

const mapStateToDispatch = (dispatch) => ({
  handleInit : (form, page) => {dispatch(actions.systemMasterInit(MASTER_TYPE, form, page))},
  handleFormEditClick : (id) => () => {
    dispatch(reset(`${MASTER_TYPE}MasterForm`));
    dispatch(actions.userMasterFormEdit(MASTER_TYPE, id))
  },
  handleFormDeleteClick : (id, page, close, form) => () => {
    close()
    dispatch(actions.userMasterFormDelete(MASTER_TYPE, id, page, form))
  },
  handleFormResetClick : () => {dispatch(actions.reducerMasterFormReset(MASTER_TYPE))},

  handleFormRegistClick : (id, page, form) => (values) => {
    const errors = validate(values)
    if (Object.keys(errors).length) {
      dispatch(stopSubmit(`${MASTER_TYPE}MasterForm`, errors))
      return
    }
    dispatch(actions.userMasterFormRegist(MASTER_TYPE, id, values, page, form))
  },
  handleFormSearchClick : (pageReset) => (values) => {
    const errors = validateSearch(values)
    if (Object.keys(errors).length) {
      dispatch(stopSubmit(`${MASTER_TYPE}MasterForm`, errors))
      return
    }
    pageReset()
    dispatch(actions.userMasterSearch(MASTER_TYPE, 1, values))
  },
  handlePageClick : (page, form) => {
    dispatch(actions.userMasterSearch(MASTER_TYPE, page, form))
  },
  handleLocalStorageSave : (values) => {
    if (!window.localStorage) {
      window.alert('お使いのブラウザでは固定できません。他のブラウザを使用して下さい。')
      return
    }
    window.localStorage.setItem(MASTER_TYPE, JSON.stringify(values))
    dispatch(actions.reducerSnackBar(true, '入力値を固定しました。', colors.green400))
  },
})

CostMasterPage = connect(
  mapStateToProps,
  mapStateToDispatch
)(CostMasterPage)

export default CostMasterPage;



// WEBPACK FOOTER //
// ./src/containers/master/cost/CostMasterPage.js